import { useMutation, UseMutationResult, useQueryClient } from "@tanstack/react-query";
import { enum_api_uri } from "../utils/enum";
import axiosInstance from "./axiosInstanse";

export interface addressRequest {
    a_company: string;
    a_tel: string;
    a_name: string;
    a_mobile: string;
    a_post: string;
    a_address: string;
    a_address_detail: string;
}

export interface addressResponse {
    statusCode: number;
    message: string;
}

export const usePostAddress = (
    successCallback?: (data: addressResponse) => void,
): UseMutationResult<addressResponse, Error, addressRequest, unknown> => {
    const queryClient = useQueryClient();

    return useMutation<addressResponse, Error, addressRequest>({
        mutationFn: async (addressData: addressRequest) => {
            const response = await axiosInstance.post(enum_api_uri.post_address, addressData);
            return response.data;
        },
        onSuccess: data => {
            queryClient.invalidateQueries({ queryKey: ["usePostAddressBook"] });
            successCallback?.(data);
        },
    });
};
